import { TableComponentProps } from "../types/pdf-types";
import { PDF_CONFIG } from "../config/pdf-config";
import autoTable, { Styles } from "jspdf-autotable";

const getHeaderStyles = (): Partial<Styles> => ({
  font: "helvetica",
  fontStyle: "bold",
  fillColor: "#f5f6f7",
  textColor: "#4D4D4D",
  fontSize: 7,
  halign: "left" as const,
  cellPadding: { top: 4, right: 2, bottom: 4, left: 2 }
});

const getBodyStyles = (): Partial<Styles> => ({
  font: "helvetica",
  fontStyle: "normal",
  textColor: "#4D4D4D",
  fontSize: 7,
  halign: "left" as const,
  cellPadding: { top: 4, right: 2, bottom: 4, left: 2 },
  cellWidth: "wrap"
});

const handleDidDrawCell = (props: TableComponentProps, cell: any) => {
  const { doc } = props;
  if (cell.section === "body") {
    doc.setFillColor("#E0E0E0");
    doc.rect(
      cell.row.cells[0].x + 0.05,
      cell.row.cells[0].y + cell.row.height,
      195,
      0.2,
      "F"
    );
    doc.setFillColor("#fff");
  }
};

const drawHighlightedCell = (cell: any, columnIdx: number) => {
  cell.row.cells[columnIdx].text
    .filter((item: any) => item !== "")
    .forEach((_: any, index: number) => {
      const x = cell.row.cells[columnIdx].x + 0.7;
      const y =
        cell.row.cells[columnIdx].y +
        cell.row.cells[columnIdx].contentHeight /
          (1.6333 +
            1.75 *
              cell.row.cells[columnIdx].text.filter((item: any) => item !== "")
                .length) +
        (0.0083 + 5.675 * index);
      const width = cell.row.cells[columnIdx].contentWidth - 1;

      cell.doc.setFillColor("#EBECF0");
      cell.doc.roundedRect(x, y, width, 4, 1, 1, "F");
      cell.doc.setFillColor("#fff");
    });
};

const drawCellData = (cell: any) => {
  if (cell.section === "body") {
    const productIdx = 3;
    const destinationUrsaCodeIdx = 6;

    if (cell.column.dataKey === "ddProductType") {
      drawHighlightedCell(cell, productIdx);
    }
    if (cell.column.dataKey === "ddDestinationUrsaCode") {
      drawHighlightedCell(cell, destinationUrsaCodeIdx);
    }
  }
};

const handleWillDrawCell = (props: TableComponentProps, cell: any) => {
  drawCellData(cell);
};

export const drawTable = (props: TableComponentProps) => {
  const { doc, data, translate } = props;
  const keyMap: Record<string, string> = {
    "No.": "dispatch.no",
    "No. STT": "dispatch.noStt",
    "No. referensi": "dispatch.noReferensi",
    "Jenis pengiriman": "dispatch.jenisPengiriman",
    "No. DEM": "dispatch.noDem",
    "Total koli": "dispatch.totalKoli",
    "Ursa code": "dispatch.ursaCode",
    "Alasan gagal": "dispatch.failedReason"
  };
  const columns = PDF_CONFIG.tableColumns.map(col => ({
    ...col,
    header: translate ? translate(keyMap[col.header] || col.header) : col.header
  }));
  autoTable(doc, {
    body: data,
    columns,
    theme: "plain",
    startY: 43,
    margin: { top: 7, left: 7, right: 7, bottom: 7 },
    headStyles: getHeaderStyles(),
    bodyStyles: getBodyStyles(),
    columnStyles: PDF_CONFIG.columnStyles,
    didDrawCell: (cell: any) => handleDidDrawCell(props, cell),
    willDrawCell: (cell: any) => handleWillDrawCell(props, cell)
  });
};
